import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../environments/environment';
@Injectable({
  providedIn: 'root'
})
export class ApiHandlerService {

  url = environment.omniAPIUrl;
  menuListUrl = `${this.url}/marketing/menu`;
  postsUrl = `${this.url}/marketing/posts/list`;
  postDetailUrl = `${this.url}/marketing/posts/detail`;
  submitWPRequest = `${this.url}/marketing/posts/whitepaper`;
  airoRequest = `${this.url}/marketing/airohub`;
  airoDetailRequest = `${this.url}/marketing/airohub`;
  omniPackageUrl = `${this.url}/admin/packages/public`;
  registerEventsUrl = `${this.url}/marketing/events/register`;
  marketingEventsUrl = `${this.url}/marketing/events/public`;

  constructor(private http: HttpClient) { }

  post(url,payload){
    return this.http.post(url,payload);
  }

  becomePartner(url, payload){
    return this.http.post(url, payload)
  }

  getMenuList(){
    return this.http.get(this.menuListUrl);
  }

  getPosts(obj){
    return this.http.post(this.postsUrl, obj);
  }

  getPostDetail(obj){
    return this.http.post(this.postDetailUrl, obj);
  }

  submitWhitepaperRequest(obj){
    return this.http.post(this.submitWPRequest, obj);
  }

  getPOCList(obj){
    return this.http.post(this.airoRequest, obj);
  }

  getPOCDetail(slug){
    return this.http.get(this.airoRequest + "/"+slug);
  }

  getOmniPackageService(){
    return this.http.get(this.omniPackageUrl)
  }

  registerEventsService(obj:any){
    return this.http.post(this.registerEventsUrl, obj)
  }

  getEventListService(obj:any){
    let queryParams = "?";
    let itemArray = Object.keys(obj);
    for(let i=0; i<itemArray.length; i++){
      if(obj[itemArray[i]]){
        queryParams += itemArray[i]+"="+obj[itemArray[i]]+"&"
      }
    }
    queryParams = queryParams.slice(0, -1);
    return this.http.get(this.marketingEventsUrl+queryParams)
  }

  getEventDetails(slug:string){
    return this.http.get(`${this.marketingEventsUrl}/${slug}`)
  }
}
